import { render, staticRenderFns } from "./PdfDocumentMobile.vue?vue&type=template&id=254ffe79&scoped=true"
import script from "./PdfDocumentMobile.vue?vue&type=script&lang=js"
export * from "./PdfDocumentMobile.vue?vue&type=script&lang=js"
import style0 from "./PdfDocumentMobile.vue?vue&type=style&index=0&id=254ffe79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254ffe79",
  null
  
)

export default component.exports